import React, { useEffect, useState } from 'react';
import { doc, onSnapshot, setDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { MaintenanceGateModal } from './MaintenanceGate';

// ══════════════════════════════════════════════════════════════════
//  MAINTENANCE GATE — kawalan admin (dalam /admin/announce) (2026-09-28)
//  - Tulis config/maintenance_gate. Write = admin sahaja (rule config/{docId}).
//  - ON → semua pelanggan log masuk nampak modal tanpa butang tutup.
//    Admin/moderator tidak disekat (useMaintenanceGate.js).
//  ⚠️ Halaman ini berpagar PIN, dan semakan PIN = Cloud Function. Bila
//    server betul-betul down, admin mungkin TAK dapat masuk ke sini —
//    keputusan user 28 Sept: kekal berpagar PIN.
// ══════════════════════════════════════════════════════════════════

const KOSONG = { enabled: false, title: '', body: '' };

export default function MaintenanceGateAdmin({ S }) {
  const [draf, setDraf] = useState(null);
  const [asal, setAsal] = useState('');
  const [hidupServer, setHidupServer] = useState(false);
  const [status, setStatus] = useState(''); // '' | 'menyimpan' | 'siap' | 'ralat'
  const [pratonton, setPratonton] = useState(false);

  useEffect(() => onSnapshot(
    doc(db, 'config', 'maintenance_gate'),
    (snap) => {
      const d = snap.exists() ? snap.data() : {};
      const bersih = { enabled: d.enabled === true, title: d.title || '', body: d.body || '' };
      setHidupServer(bersih.enabled);
      setAsal(JSON.stringify(bersih));
      setDraf((prev) => (prev === null ? bersih : prev));
    },
    (e) => {
      console.error('[MaintenanceGate] baca gagal', e);
      setDraf((prev) => (prev === null ? { ...KOSONG } : prev));
    }
  ), []);

  if (draf === null) return <div style={S.card}>Loading maintenance gate…</div>;

  const berubah = JSON.stringify(draf) !== asal;

  const simpan = async () => {
    if (draf.enabled && !hidupServer
      && !window.confirm('Turn ON the maintenance gate?\n\nEvery customer will be blocked by a popup they cannot close until you turn it OFF.')) return;
    setStatus('menyimpan');
    try {
      await setDoc(doc(db, 'config', 'maintenance_gate'), {
        enabled: !!draf.enabled,
        title: draf.title.trim().slice(0, 120),
        body: draf.body.trim().slice(0, 1500),
        updatedAt: serverTimestamp(),
        updatedBy: auth.currentUser?.email || '',
      }, { merge: true });
      setStatus('siap');
      setTimeout(() => setStatus(''), 2500);
    } catch (e) {
      console.error('[MaintenanceGate] simpan gagal', e);
      setStatus('ralat');
    }
  };

  const merah = '#dc2626';

  return (
    <>
      <h2 style={{ ...S.h1, fontSize: 18, marginTop: 36 }}>Maintenance gate</h2>
      <p style={S.sub}>
        Block every customer with a popup that <b>cannot be closed</b> (e.g. when the server is down).
        Customers can still log in, but cannot use anything. Admin accounts are not blocked.
        Turning it OFF removes the popup for everyone within seconds — no refresh needed.
      </p>

      <div style={{ ...S.card, border: hidupServer ? `2px solid ${merah}` : S.card.border }}>
        <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, color: hidupServer ? merah : 'var(--s-ink-2, #666)' }}>
          Live status: {hidupServer ? 'ON — customers are blocked right now' : 'OFF'}
        </div>
        <label style={S.toggle}>
          <input type="checkbox" checked={draf.enabled} onChange={(e) => setDraf({ ...draf, enabled: e.target.checked })} style={{ width: 18, height: 18 }} />
          {draf.enabled ? 'Gate ON' : 'Gate OFF'}
        </label>
      </div>

      <div style={S.card}>
        <label style={S.label}>Title (optional)</label>
        <input style={S.input} value={draf.title} maxLength={120} placeholder="Default: System under maintenance"
               onChange={(e) => setDraf({ ...draf, title: e.target.value })} />
        <label style={S.label}>Message (optional)</label>
        <textarea style={{ ...S.input, ...S.ta }} value={draf.body} maxLength={1500}
                  placeholder="Default: SESAAT is temporarily unavailable while we fix an issue. Please try again shortly."
                  onChange={(e) => setDraf({ ...draf, body: e.target.value })} />
        <div style={S.row}>
          <button style={{ ...S.btn, ...S.primary, opacity: berubah ? 1 : 0.5, cursor: berubah ? 'pointer' : 'default' }}
                  disabled={!berubah || status === 'menyimpan'} onClick={simpan}>
            {status === 'menyimpan' ? 'Saving…' : status === 'siap' ? '✓ Saved' : 'Save'}
          </button>
          <button style={{ ...S.btn, ...S.ghost }} onClick={() => setPratonton(true)}>Preview popup</button>
          {status === 'ralat' && <span style={{ color: merah, fontSize: 13 }}>Save failed — try again.</span>}
        </div>
      </div>

      {pratonton && (
        <MaintenanceGateModal title={draf.title.trim()} body={draf.body.trim()} onTutup={() => setPratonton(false)} />
      )}
    </>
  );
}
